<template>

  <div id="app" style="width:100%;height:100%;position:absolute;">
			<Header v-show="hideHeader"
							:hide="back"
							@back="backHandle"
							:title="title"
							:className="transi"
							:backMessage="backMessage">
			</Header>

    <transition
      :name="transitionName"
      mode="out-in"
    >
      <router-view />
    </transition>
    <loading :IsShow="IsLoading"></loading>
  </div>
</template>



<style scoped>
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active,
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  will-change: transform;
  transition: all 0.5s;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 1;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 1;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-up-enter {
  /* opacity: 1; */
  transform: translate3d(0, 100%, 0);
}
.slide-up-leave-active {
  /* opacity: 0; */
  transform: translate3d(0, 0, 0);
}
.slide-down-enter {
  /* opacity: 1; */
  transform: translate3d(0, 0, 0);
}
.slide-down-leave-active {
  /* opacity: 0; */
  transform: translate3d(0, 100%, 0);
}

.isDisplayLogin {
  display: black;
}
</style>

<script>
import Header from "@/components/headers/Header.vue";
import Loading from "@/components/loading/loading";
import { mapState } from "vuex";
import MobileApi from "@/common/MobileApi";

export default {
  components: {
    Header,
    Loading
  },
  data() {
    return {
      transitionName: "",
      title: "",
      back: false,
			backMessage:null,
      backObj: [],
      transi: "",
      hideHeader: false
    };
  },
  computed: {
    ...mapState({
      IsLoading: state => state.Loading.IsLoading,
      isApp: state => state.App.isApp
    })
  },
  created() {
    MobileApi.init();
  },
  mounted() {
    this.$store.dispatch("App/initState");
    if(!this.$isIOS) {
      let _this = this;
      setTimeout(() => {


      let textareaList = document.querySelectorAll("textarea");
      // let inputList = document.querySelectorAll("input");
      textareaList.forEach(function(item, i) {
          item.addEventListener("focus", function(e) {
            _this.up(e.target);
          });
          item.addEventListener("blur", function(e) {
            _this.down(e.target);
          });
      });

      // inputList.forEach(function(item, i) {
      //   item.addEventListener("focus", function(e) {
      //     _this.up(e.target);
      //   });
      //   item.addEventListener("blur", function(e) {
      //     _this.down(e.target);
      //   });
      // });
       }, 1500);
    }
  },
  methods: {
    backHandle() {
      const backObject = this.backObj.pop();
      this.$store.dispatch("Loading/Enable");
      this.$router.push({ ...backObject });
    },
    up(target) {
      const wH = screen.availHeight;
      const elTop = wH * 0.3;
      var tagName = target.tagName.toLowerCase();
      var app = document.getElementById("app");
      // var eH = e.target;
      if (tagName == "textarea" || tagName == "input") {
        app.style.cssText =
          "position: absolute; width: 100%; height: 100%; overflow:hidden; bottom: " +
          elTop +
          "px";
      }
    },
    down(target) {
      var tagName = target.tagName.toLowerCase();
      var app = document.getElementById("app");
      if (tagName == "textarea" || tagName == "input") {
        app.style.cssText =
          "position: initial; width: auto; height: auto; bottom: auto";
      }
    }
  },
  watch: {
    $route(to, from) {
      this.$layer.closeAll(); // 关闭模态层(android 物理键返回)

      this.$store.dispatch("Loading/Enable");
      this.title = to.meta.title;
			this.backMessage = to.meta.backMessage;
      this.back = false;
      this.back = to.meta.index < 1;

      if (from.meta.index < to.meta.index) {
        this.backObj.push(from);
      } else if (from.meta.index >= to.meta.index) {
        this.backObj = this.backObj.filter(item => {
          return item.meta.index < to.meta.index;
        });
      }
      //解决特殊页面隐藏返回ICON ，单独设定
      if (to.meta.hideBack) {
        this.back = true;
      }

      if (to.meta.app && this.isApp) {
        this.hideHeader = false;
      } else {
        this.hideHeader = true;
      }

			let s=["selectshop"];
			if(s.includes(to.name)) //工作台特殊处理
			{
			  this.hideHeader = false;
			}

      if (this.isApp) {
        window.$mobile.navigationShow(false);
      }

      //添加这个参数，目的是为特殊页面直接提供上下拉动画，不受左右影响
      if (to.meta.disableLR && !this.isApp) {
        if (to.meta.transitionName === "updown") {
          this.transitionName = "slide-up";
        } else if (from.meta.transitionName === "updown") {
          this.transitionName = "slide-down";
        }
      } else if (!this.$isDing && !this.isApp) {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        if (to.meta.index > from.meta.index) {
          //设置动画名称
          this.transitionName = "slide-left";
          this.transi = "transiTo";
          if (to.meta.transitionName === "updown") {
            this.transitionName = "slide-up";
          }
        } else {
          this.transi = "transiFrom";
          if (from.meta.transitionName === "updown") {
            this.transitionName = "slide-down";
          } else {
            this.transitionName = "slide-right";
          }
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue